var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pad20 bg-f2" }, [
    _c("div", { staticClass: "f22 mar20-b lh-1 text-center" }, [
      _vm._v("供应商对账单")
    ]),
    _c(
      "div",
      { staticClass: "bg-white pad15 f15 radius10" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 24 } }, [
              _c("span", { staticClass: "fb" }, [_vm._v("单位：")]),
              _vm._v(_vm._s(_vm.info.purchaseOrgName))
            ])
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "mar10-tb" },
          [
            _c("el-col", { attrs: { span: 6 } }, [
              _c("span", { staticClass: "fb" }, [_vm._v("供应商：")]),
              _vm._v(_vm._s(_vm.info.supplierShopName))
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _c("span", { staticClass: "fb" }, [_vm._v("联系人：")]),
              _vm._v(_vm._s(_vm.info.supplierLinkManName))
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _c("span", { staticClass: "fb" }, [_vm._v("联系方式：")]),
              _vm._v(_vm._s(_vm.info.supplierLinkManPhone))
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _c("span", { staticClass: "fb" }, [_vm._v("对账期间：")]),
              _vm._v(_vm._s(_vm.info.paycheckDatePeriod))
            ])
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 6 } }, [
              _c("span", { staticClass: "fb" }, [_vm._v("提货日期：")]),
              _vm._v("订单完结（确认收货）日期")
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _c("span", { staticClass: "fb" }, [_vm._v("付款日期：")]),
              _vm._v("订单结算日期")
            ])
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "text-center pad15-tb f20" }, [
      _vm._v("一、账单明细")
    ]),
    _c(
      "div",
      { staticClass: "bg-white pad15 f15 radius10" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.info.purchasePayCheckOrderDetailList }
          },
          [
            _c("el-table-column", {
              attrs: { width: "100", prop: "busTypeCn", label: "业务类型" }
            }),
            _c("el-table-column", {
              attrs: { width: "120", prop: "busDate", label: "日期" }
            }),
            _c("el-table-column", {
              attrs: { width: "170", prop: "orderId", label: "订单号" }
            }),
            _c("el-table-column", {
              attrs: { prop: "orderGoodsName", label: "商品名称" }
            }),
            _c("el-table-column", {
              attrs: { prop: "standardPackNum", label: "件数" }
            }),
            _c("el-table-column", {
              attrs: { prop: "goodsQuantity", label: "数量" }
            }),
            _c("el-table-column", {
              attrs: { prop: "sellFactPrice", label: "单价" }
            }),
            _c("el-table-column", {
              attrs: { prop: "goodsSpec", label: "价格单位" }
            }),
            _c("el-table-column", {
              attrs: { prop: "busAmount", label: "金额" }
            }),
            _c("el-table-column", {
              attrs: { prop: "debtAmount", label: "欠款余额" }
            }),
            _c("el-table-column", { attrs: { width: "100", label: "备注" } })
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "text-center pad15-tb f20" }, [
      _vm._v("二、对账回执")
    ]),
    _c(
      "div",
      { staticClass: "bg-white pad15 f15 radius10" },
      [
        _c("div", { staticClass: "pad5-tb" }, [
          _vm._v(
            "\n      截止" +
              _vm._s(_vm.info.payCheckDateEnd) +
              "止，我单位" +
              _vm._s(_vm.info.purchaseOrgName) +
              "，于贵单位（" +
              _vm._s(_vm.info.supplierShopName) +
              "）的账面欠款余额为" +
              _vm._s(_vm.info.endDebtAmount) +
              "（" +
              _vm._s(_vm.info.endDebtAmountCn) +
              "） （正数表示我方欠款，负数表示我方预付款），详细欠款见下表。\n    "
          )
        ]),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: [
                {
                  beginDebtAmount: _vm.info.beginDebtAmount,
                  needBalanceAmount: _vm.info.needBalanceAmount,
                  hadBalanceAmount: _vm.info.hadBalanceAmount,
                  endDebtAmount: _vm.info.endDebtAmount
                }
              ]
            }
          },
          [
            _c("el-table-column", {
              attrs: { prop: "beginDebtAmount", label: "期初欠款" }
            }),
            _c("el-table-column", {
              attrs: { prop: "needBalanceAmount", label: "本期应付" }
            }),
            _c("el-table-column", {
              attrs: { prop: "hadBalanceAmount", label: "本期付款" }
            }),
            _c("el-table-column", {
              attrs: { prop: "endDebtAmount", label: "期末欠款" }
            })
          ],
          1
        ),
        _c("div", { staticClass: "flex pad50-t justify-end" }, [
          _vm._m(0),
          _c("div", { staticClass: "pad5-t" }, [
            _c("p", [_vm._v(" ")]),
            _c("p", [_vm._v(_vm._s(_vm.date))])
          ])
        ])
      ],
      1
    ),
    _vm._m(1),
    _c("div", { staticClass: "pad50" }),
    _c(
      "div",
      { staticClass: "text-right suction-bottom" },
      [
        _c(
          "el-button",
          {
            on: {
              click: function($event) {
                return _vm.$router.back()
              }
            }
          },
          [_vm._v("取 消")]
        ),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.confirm } },
          [_vm._v("确 定")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pad5-tb" }, [
      _c("p", { staticClass: "text-right" }, [_vm._v("客户签字（盖章）：")]),
      _c("p", { staticClass: "text-right" }, [_vm._v("签字日期：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-white mar20-t pad15 f15 radius10" }, [
      _c("p", [_vm._v("备注")]),
      _c("p", [
        _vm._v(
          "1. 本对账单是本公司与供应商结算对账的法律凭证，供应商签字或盖章后生效，效力等同于购销合同、收货凭证等相关业务单证。"
        )
      ]),
      _c("p", [
        _vm._v(
          "2. 本对账单生效后双方不得以任何理由抗辩，本对账单所涉货款的结算日期以《购销合同》约定为准；因上述货款引起的任何纠纷，由本公司所在地人民法院管辖。"
        )
      ]),
      _c("p", [
        _vm._v(
          "3. 为保障您的资金安全，请勿将您的现金或银行卡密码交给公司业务人员，若由此产生的所有风险将由您自行承担。"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }